import { Plugin } from "vue";
import { useUserStore } from "~stores/User.ts";

function numberFormat(number: string | number | unknown, options?: { minDecimals: number; maxDecimals: number }) {
	let numberToFormat = number;

	if (typeof numberToFormat === "string") {
		numberToFormat = Number.parseFloat(numberToFormat);
	}

	const defaultOptions = {
		minDecimals: 0,
		maxDecimals: 2,
	};
	const resolvedOptions = Object.assign({}, defaultOptions, options ?? {});
	const numberFormatter = Intl.NumberFormat("nl-NL", {
		minimumFractionDigits: resolvedOptions.minDecimals,
		maximumFractionDigits: resolvedOptions.maxDecimals,
	});

	return numberFormatter.format(numberToFormat);
}

const plugin: Plugin = {
	install: (app, options) => {
		// inject a globally available $numberFormat() method
		app.config.globalProperties.$numberFormat = (number, options) => {
			return numberFormat(number, options);
		};
	},
};

export { numberFormat };
export default plugin;

declare module "vue" {
	interface ComponentCustomProperties {
		$numberFormat: (number: number | string, options?: { minDecimals?: number; maxDecimals?: number }) => string;
	}
}
